import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import AnimatedRoutes, { absolute } from '../../components/AnimatedRoutes';
import { getImageUrl, navigate } from '../../../../helpers';
import BackgroundImage from '../../components/BackgroundImage';
import Button from '../../components/Button';
import Content from '../../components/Content';
import Header from '../../components/Header';
import Maps from '../Maps';
import Subheader from '../../components/Subheader';
import styles from './exhibitors.scss';
import withUser from '../../../../components/withUser';

const AbsoluteMap = absolute(Maps, true);

const propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    pub_exhibitors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })),
  }),
  // dispatch: PropTypes.func.isRequired,
  onRequestOpenFn: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  match: PropTypes.shape(),
  // loading: PropTypes.bool,
};

class Exhibitors extends React.Component {
  render() {
    const {
      event,
      history,
      location,
      match,
    } = this.props;
    const unsortedExhibitors = (event && event.pub_exhibitors) || [];

    // Sort all exhibitors by alphabetical order.
    const exhibitors = unsortedExhibitors.sort((a, b) => {
      if (a.name.toUpperCase() > b.name.toUpperCase()) {
        return 1;
      } if (a.name.toUpperCase() < b.name.toUpperCase()) {
        return -1;
      }
      return 0;
    })
      .filter((ex) => ['exhibitor', 'sponsor'].includes(ex.type));

    // Sort highlighted exhibitors by sort order, then in alphabetical order.
    const highlightedExhibitors = exhibitors
      .filter((exhibitor) => exhibitor.highlighted)
      .slice().sort((a, b) => {
        if (b.sort > a.sort) {
          return 1;
        } if (a.sort > b.sort) {
          return -1;
        }
        return 0;
      });
    const { /* event, */ onRequestOpenFn } = this.props;
    return (
      <>
        <Header
          onMenuOpen={onRequestOpenFn}
          history={history}
          showUser
        >
          Expo & partners
        </Header>
        <Content>
          { highlightedExhibitors?.length > 0 && (
            <Subheader>Highlighted exhibitors & partners</Subheader>
          )}
          <div className={styles.highlighted}>
            { highlightedExhibitors.map((exhibitor) => (
              <BackgroundImage
                key={exhibitor.id}
                className={styles.highlight}
                src={getImageUrl(exhibitor.image)}
              >
                <div className={styles.name}>
                  {exhibitor.name}
                </div>
                <div className={styles.description}>
                  {exhibitor.description}
                </div>
                <div className={styles.buttons}>
                  { exhibitor.url
                    && (
                    <Button
                      outline
                      colors={{
                        text: '#fff',
                        border: '#fff',
                      }}
                      onClick={() => window.open(exhibitor.url)}
                    >
                      Read more &rarr;
                    </Button>
                    )}
                  { (exhibitor.area || exhibitor.pin)
                    && (
                    <Button
                      outline
                      colors={{
                        text: '#fff',
                        border: '#fff',
                      }}
                      onClick={() => navigate(history, `${match.url}/map/${exhibitor.id}`)}
                    >
                      <i className="far fa-map-marker" />
                      {' '}
                      Show on map
                    </Button>
                    )}
                </div>
              </BackgroundImage>
            ))}
          </div>
          { exhibitors?.length > 0 && <Subheader>All exhibitors & partners</Subheader> }
          <div className={styles.list}>
            { exhibitors.map((exhibitor) => (
              <div
                className={styles.exhibitor}
                key={exhibitor.id}
              >
                <div className={styles.name}>
                  {exhibitor.name}
                </div>
                { (exhibitor.area || exhibitor.pin)
                  && (
                  <div
                    className={styles.needle}
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate(history, `${match.url}/map/${exhibitor.id}`)}
                  >
                    <i className="far fa-map-marker-alt" />
                  </div>
                  )}
              </div>
            ))}
          </div>
        </Content>
        <AnimatedRoutes location={location}>
          <Route exact path={`${match.url}/map/:exhibitor`} render={(props) => (<AbsoluteMap {...props} />)} />
        </AnimatedRoutes>
      </>
    );
  }
}

Exhibitors.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.getIn(['event', 'loading']),
    event: state.getIn(['event', 'data']),
  };
}

export default withUser(connect(mapStateToProps)(Exhibitors));
